import { render, staticRenderFns } from "./BodyAnatomyTypeEdit.vue?vue&type=template&id=0f6d2c1c&scoped=true&"
import script from "./BodyAnatomyTypeEdit.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d2c1c",
  null
  
)

export default component.exports